<template>
  <div class="global-loading-bar" :class="{ 'is-active': isLoading }">
    <div class="global-loading-bar__track">
      <div class="global-loading-bar__fill"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalLoadingBar',
  computed: {
    isLoading () {
      return this.$store.getters.GetIsLoading
    }
  }
}
</script>

<style lang="css" scoped>
.global-loading-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 60000;
  pointer-events: none;
  opacity: 0;
  transition: opacity 200ms ease;
}

.global-loading-bar.is-active {
  opacity: 1;
}

.global-loading-bar__track {
  position: relative;
  width: 100%;
  height: 100%;
  background: transparent;
  overflow: hidden;
}

.global-loading-bar__fill {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 40%;
  background: linear-gradient(90deg, rgba(115, 103, 240, 0) 0%, #7367f0 50%, rgba(115, 103, 240, 0) 100%);
  animation: global-loading-bar-slide 1.1s ease-in-out infinite;
  will-change: transform;
}

@keyframes global-loading-bar-slide {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(350%);
  }
}
</style>
